<!--&================== TITLE LIBRARY ==================&-->
<div class="title-components">
  <h1>Processes</h1>
</div>





<!--&================== DIVIDER BUTONS LIBRARY ==================&-->

<div class="divider-butons">
  <button (click)="ToggleModalHelp(true)" class="btn btn-icon-text-left">
    <span class="text">Ayuda</span><i class="fa-regular fa-circle-question"></i>
  </button>
  <div routerLink="/Dashboard/FIN/SeeAllTasksLibFIN" class="btn btn-icon-text-left">
    <span class="text">Tareas</span><i class="fa-regular fa-bell"></i>
    <span class="number-circle">{{Total_Task()}}</span>
  </div>
</div>


<!--&================== CONTAINER GENERAL LIBRARY ==================&-->
<div class="container-global-components ConFLFIN">

  <!---================= CONTAINER FOR SHOW ROUTE (DESKTOP) =================--->
  <div class="Show-Route" *ngIf="!isMobileDevice"><i class="fas fa-folder"></i><i class="fas fa-angle-right"></i>
    <div (click)="SeeFolder_BreadCrum(i)" class="Route-Generator" *ngFor="let ruta of Header_Routes; let i=index"
      [attr.data-index]="i" (dragover)="OnBreadcrumbDragOver($event, i)" (dragleave)="OnBreadcrumbDragLeave($event, i)"
      (drop)="OnBreadcrumbDrop($event, i)" [class.route-drop-target]="dragOverBreadcrumbIndex === i">
      <span>{{ruta.split('§').pop()}}</span> <i class="fas fa-angle-right"></i>
    </div>
  </div>

  <!---================= SHOW CREATE CARPET OR FIN AND SEE ALL DIRECTORIES AND FINS =================--->
  <div class="SectionCreateTotal section-actions-fin">
    <div class="left-CT">
      <button (click)="ToggleModalAddFIN(true)" class="btn-icon-text"
        *ngIf="(UserRoleIn([PermissionFIN.createFile]) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorFIN])) && !Enable_BtnNewFIN() && LoadPage">
        <i class="fa-solid fa-plus"></i><span class="text">Cargar Proceso</span>
      </button>
      <button (click)="Open_Massive_Upload_FIN()" class="btn-icon-text"
        *ngIf="(UserRoleIn([PermissionFIN.createFile]) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorFIN])) && !Enable_BtnNewFIN() && LoadPage">
        <i class="fa-solid fa-file-circle-plus"></i><span class="text">Carga Múltiple</span>
      </button>
      <input #inputMassiveFIN type="file" multiple [attr.accept]="Get_Main_File_Accept_FIN()" style="display: none;"
        (change)="On_Select_Files_Massive_FIN($event)">
      <button (click)="ToggleModalAddFolderFIN(true)" class="btn-icon-text"
        *ngIf="(UserRoleIn([PermissionFIN.createFolder]) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorFIN]))">
        <i class="fa-solid fa-folder-plus"></i><span class="text">Crear Carpeta</span>
      </button>
      <div class="btn-icon-text file-type-selector"
        *ngIf="(UserRoleIn([PermissionFIN.createFile]) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorFIN])) && !Enable_BtnNewFIN() && LoadPage"
        title="Seleccione el tipo de archivo permitido para la carga principal">
        <i class="fa-solid fa-list-check"></i>
        <span class="text">Tipo Archivo</span>
        <div class="selector-wrap">
          <select class="selector-input" [(ngModel)]="MainFileTypeFIN" (change)="On_Main_File_Type_Change_FIN()">
            <option *ngFor="let option of MainFileTypeOptionsFIN" [value]="option.Value">{{option.Label}}</option>
          </select>
          <i class="fa-solid fa-chevron-down selector-chevron"></i>
        </div>
      </div>
    </div>
    <div class="right-CT" style="display: flex; flex-direction: column; align-items: flex-end; gap: 8px;">
      <div style="display: flex; gap: 15px;">
        <div class="AllDirectories">Total de Carpetas: <b>{{this.TotalFoldersF}}</b> <i class="fas fa-folder"></i></div>
        <div class="AllFiles">Total de Procesos: <b>{{this.TotalFilesFIN}}</b> <i class="fas fa-file"></i></div>
      </div>
      <div style="display: flex; gap: 8px;" *ngIf="LoadPage && !isMobileDevice">
        <button (click)="RefreshCurrentDirectory()" class="btn-icon-text" style="font-size: 13px; padding: 6px 12px; background-color: #20a8e1; color: white; border: none;">
          <i class="fa-solid fa-rotate"></i>
          <span class="text">Actualizar</span>
        </button>
        <button (click)="ToggleMultiSelectMode()" class="btn-icon-text" [ngClass]="{'btn-icon-text-outlined': IsMultiSelectMode}" style="font-size: 13px; padding: 6px 12px;">
          <i class="fa-solid" [ngClass]="IsMultiSelectMode ? 'fa-check-double' : 'fa-list-check'"></i>
          <span class="text">{{ IsMultiSelectMode ? 'Cancelar Selección' : 'Seleccionar' }}</span>
        </button>
        <button *ngIf="IsMultiSelectMode && SelectedALL_FAF_FIN.length > 0" (click)="DeleteSelectedItems()" class="btn-icon-text" style="font-size: 13px; padding: 6px 12px; background-color: #f15a24; color: white; border: none;">
          <i class="fa-solid fa-trash-can"></i>
          <span class="text">Borrar Selección</span>
        </button>
      </div>
    </div>
  </div>

  <!---================= CONTAINER FOR SHOW ROUTE (MOBILE) =================--->
  <div class="Show-Route" *ngIf="isMobileDevice"><i class="fas fa-folder"></i><i class="fas fa-angle-right"></i>
    <div (click)="SeeFolder_BreadCrum(i)" class="Route-Generator" *ngFor="let ruta of Header_Routes; let i=index"
      [attr.data-index]="i" (dragover)="OnBreadcrumbDragOver($event, i)" (dragleave)="OnBreadcrumbDragLeave($event, i)"
      (drop)="OnBreadcrumbDrop($event, i)" [class.route-drop-target]="dragOverBreadcrumbIndex === i">
      <span>{{ruta.split('§').pop()}}</span> <i class="fas fa-angle-right"></i>
    </div>
  </div>

  <!---================= CONTAINER FOR TABLE LIBRARY =================--->
  <div class="Table-Lib Table-container-FIN"
    [class.Table-container-FIN-empty]="LoadPage && (!All_FAF_FIN || All_FAF_FIN.length === 0)">

    <p-table #dtFIN [value]="All_FAF_FIN" [(selection)]="SelectedALL_FAF_FIN" dataKey="ID" [rowHover]="true" [rows]="10"
      [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,15,25, 50]" [paginator]="true"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" [filterDelay]="0"
      [globalFilterFields]="['Name','Purpose','Code','Revision_No','Contributor_Name']">


      <!---================= SEARCH AND BACK BUTTON =================--->
      <ng-template pTemplate="caption">
        <div class="SectionCreateTotal Table_NG">
          <div class="left-CT">
            <div class="search inputText" *ngIf="Show_InputSearch()">
              <i class="fa-solid fa-magnifying-glass"></i><input [(ngModel)]="FIN_Filter" type="text"
                (input)="dtFIN.filterGlobal(FIN_Filter, 'contains')" placeholder="Buscar en el directorio" />
            </div>
          </div>
          <div class="right-CT" style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;" [style.justify-content]="isMobileDevice ? 'center' : 'flex-end'" [style.width]="isMobileDevice ? '100%' : 'auto'">
            <button (click)="GoBackFolder()" *ngIf="Header_Routes.length>1" class="btnBack btn-icon" style="height: 35px; width: 35px; min-width: 35px; display: flex; align-items: center; justify-content: center; padding: 0;">
              <i class="fa-solid fa-angles-left"></i>
            </button>
            <ng-container *ngIf="isMobileDevice && LoadPage">
              <button (click)="RefreshCurrentDirectory()" class="btn-icon-text" style="font-size: 13px; padding: 6px 12px; background-color: #20a8e1; color: white; border: none; height: 35px; display: flex; align-items: center; gap: 6px;">
                <i class="fa-solid fa-rotate"></i>
                <span class="text">Actualizar</span>
              </button>
              <button (click)="ToggleMultiSelectMode()" class="btn-icon-text" [ngClass]="{'btn-icon-text-outlined': IsMultiSelectMode}" style="font-size: 13px; padding: 6px 12px; height: 35px; display: flex; align-items: center; gap: 6px;">
                <i class="fa-solid" [ngClass]="IsMultiSelectMode ? 'fa-check-double' : 'fa-list-check'"></i>
                <span class="text">{{ IsMultiSelectMode ? 'Cancelar' : 'Seleccionar' }}</span>
              </button>
              <div *ngIf="IsMultiSelectMode && SelectedALL_FAF_FIN.length > 0" style="flex-basis: 100%; display: flex; justify-content: center;">
                <button (click)="DeleteSelectedItems()" class="btn-icon-text" style="font-size: 13px; padding: 6px 12px; background-color: #f15a24; color: white; border: none; height: 35px; display: flex; align-items: center; gap: 6px;">
                  <i class="fa-solid fa-trash-can"></i>
                  <span class="text">Borrar</span>
                </button>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem" *ngIf="IsMultiSelectMode"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
          <th>Actualizar</th>
          <th *ngIf="isMobileDevice">Opciones</th>

          <ng-container *ngFor="let Table_header of FIN_Table_Headers;let i=index">

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.IDFIN">
              <th pSortableColumn="ID" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="ID"></p-sortIcon>
                    <p-columnFilter type="text" field="ID" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.EXTEN">
              <th pSortableColumn="Extension" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Extension"></p-sortIcon>
                    <p-columnFilter field="F_Extension" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Tipo documento</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="this.Filter_Global_Check.Extension"
                          placeholder="Seleccione" optionLabel="Value" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <ng-container *ngIf="option.Value==='dir'">
                              <div class="Icon-Table-File">
                                <div class="Content-Icon">
                                  <img src="./assets/Global/icons/Folder.png" alt="" srcset="">
                                  <span>Carpeta</span>
                                </div>
                              </div>
                            </ng-container>

                            <ng-container *ngFor="let icon of Icons_Image">
                              <div *ngIf="option.Value.toUpperCase()==icon.Extension.toUpperCase()"
                                class="Icon-Table-File">
                                <div class="Content-Icon">
                                  <img src="./assets/Global/icons/{{icon.Url_Image}}" alt="" srcset="">
                                  <span>{{icon.Name}}</span>
                                </div>
                              </div>
                            </ng-container>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>

                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.NAMFI">
              <th pSortableColumn="Name" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Name"></p-sortIcon>
                    <p-columnFilter type="text" field="Name" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.ANNEX">
              <th class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.CODEF">
              <th pSortableColumn="Code" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Code"></p-sortIcon>
                    <p-columnFilter type="text" field="Code" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.DESCR">
              <th pSortableColumn="Purpose" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Purpose"></p-sortIcon>
                    <p-columnFilter type="text" field="Purpose" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.NOREV">
              <th pSortableColumn="Revision_No" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Revision_No"></p-sortIcon>
                    <p-columnFilter field="F_Revision_No" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">No. Revisión</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Revision_No"
                          placeholder="Seleccione" optionLabel="Value" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option.Value}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header.startsWith('APPR')">
              <th class="{{Table_header.Key_Header}} approver-header">
                <div class="Grid-Th">
                  <span class="approver-cell">{{Table_header.Name}}</span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.DAMOD">
              <th pSortableColumn="Date_Modification" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Date_Modification"></p-sortIcon>
                    <p-columnFilter type="date" field="Date_Modification" display="menu"
                      class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.DACRE">
              <th pSortableColumn="Date_Created" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Date_Created"></p-sortIcon>
                    <p-columnFilter type="date" field="Date_Created" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.DAEXP">
              <th pSortableColumn="Date_Expiration" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Date_Expiration"></p-sortIcon>
                    <p-columnFilter type="date" field="Date_Expiration" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.STATU">
              <th pSortableColumn="Status" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Status"></p-sortIcon>
                    <p-columnFilter field="F_Status" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Estatus</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" optionLabel="Value" [options]="Filter_Global_Check.Status"
                          placeholder="Seleccione" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">
                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>
                                  <div [ngSwitch]="option.Value">
                                    <div *ngSwitchCase='1'>Aprobado</div>
                                    <div *ngSwitchCase='2'>Pendiente</div>
                                    <div *ngSwitchCase='3'>Rechazado</div>
                                    <div *ngSwitchDefault></div>
                                  </div>
                                </span>
                              </div>
                            </div>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>

                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.CONTR">
              <th pSortableColumn="Contributor_Name" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Contributor_Name"></p-sortIcon>
                    <p-columnFilter field="F_Contributor_Name" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre Contribuidor</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Contributor_Name"
                          placeholder="Seleccione" optionLabel="Value" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option.Value}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.AREA_">
              <th pSortableColumn="Area" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Area"></p-sortIcon>
                    <p-columnFilter type="text" field="Area" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.SHOP_">
              <th pSortableColumn="Shop" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Shop"></p-sortIcon>
                    <p-columnFilter type="text" field="Shop" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>


          </ng-container>

        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-All_FAF_FIN>

        <tr class="Draggable-Row" [attr.draggable]="isMobileDevice ? 'false' : 'true'"
          (dragstart)="OnDragStart($event, All_FAF_FIN)" (dragover)="OnDragOver($event, All_FAF_FIN)"
          (dragleave)="OnDragLeave($event, All_FAF_FIN)" (dragend)="OnDragEnd($event)" (drop)="OnDrop($event, All_FAF_FIN)"
          [attr.data-id]="All_FAF_FIN.ID" (touchstart)="OnTouchStart($event, All_FAF_FIN)"
          (touchmove)="OnTouchMove($event)" (touchend)="OnTouchEnd($event)"
          [class.drag-over]="IsDraggedOver(All_FAF_FIN)"
          (contextmenu)="$event.preventDefault(); RightClick_Context_Menu($event,All_FAF_FIN)">

          <td *ngIf="IsMultiSelectMode" (touchstart)="$event.stopPropagation()" (touchend)="$event.stopPropagation()" (click)="$event.stopPropagation()">
            <p-tableCheckbox [value]="All_FAF_FIN"></p-tableCheckbox>
          </td>

          <td>
            <div class='show-example-btn' data-swal-toast-template='#my-template'
              (click)="Can_Upgrade(All_FAF_FIN,$event)"
              *ngIf="(UserRoleIn([PermissionFIN.updateFile]) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorFIN])) && !All_FAF_FIN.Directory"
              class="Update">
              <i class="fa-solid fa-file-pen"></i>
            </div>
          </td>

          <td *ngIf="isMobileDevice">
            <div class="Update" (click)="RightClick_Context_Menu($event, All_FAF_FIN, true)" style="cursor: pointer;">
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </div>
          </td>


          <td *ngFor="let Table_header of FIN_Table_Headers;let i=index">

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.IDFIN">
              {{All_FAF_FIN.ID}}
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.EXTEN">

              <div [class.Icon-Container-Mobile]="isMobileDevice"
                style="display: flex; align-items: center; gap: 10px;">

                <div (click)="OnFolderClick($event, All_FAF_FIN)" *ngIf="All_FAF_FIN.Directory" class="Folder-Table">
                  <div class="Folder_back">
                    <div class="Paper"></div>
                    <div class="Paper"></div>
                    <div class="Paper"></div>
                    <div class="Folder_front"></div>
                    <div class="Folder_front right"></div>
                  </div>
                </div>

                <ng-container *ngFor="let icon of Icons_Image">

                  <div (click)="$event.stopPropagation(); DownloadTable(All_FAF_FIN)"
                    *ngIf="All_FAF_FIN.Extension.toUpperCase()==icon.Extension.toUpperCase() && CanDownload(All_FAF_FIN)"
                    class="Icon-Table-File" style="cursor: pointer;">
                    <div class="Content-Icon">
                      <div class="Icon-BG-Touch"
                        [style.background-image]="'url(./assets/Global/icons/' + icon.Url_Image + ')'"></div>
                      <div class="ToolTip-Download">Descargar</div>
                    </div>
                  </div>

                  <div
                    *ngIf="All_FAF_FIN.Extension.toUpperCase()==icon.Extension.toUpperCase() && !CanDownload(All_FAF_FIN)"
                    class="Icon-Table-File no-download">
                    <div class="Content-Icon">
                      <div class="Icon-BG-Touch"
                        [style.background-image]="'url(./assets/Global/icons/' + icon.Url_Image + ')'"></div>
                    </div>
                  </div>

                </ng-container>
              </div> <!-- Cierre de Icon-Container-Mobile -->
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.NAMFI">
              <div (click)="OnFolderClick($event, All_FAF_FIN)" *ngIf="All_FAF_FIN.Directory"
                class="dragstar clickable-name Draggable-Name-Cell"
                [attr.draggable]="isMobileDevice ? 'false' : 'true'">
                {{All_FAF_FIN.Name}}
              </div>
              <div *ngIf="All_FAF_FIN.Directory!=true && CanDownload(All_FAF_FIN)"
                class="Container-Name-in-table dragstar clickable-name Draggable-Name-Cell"
                [attr.draggable]="isMobileDevice ? 'false' : 'true'" (click)="PreviewFile(All_FAF_FIN, $event)">
                <div *ngIf="Is_New_FIN_In_System(All_FAF_FIN.Date_Created)" class="Date-marker"><i
                    class="fa-brands fa-slack"></i></div> {{All_FAF_FIN.Name}}
              </div>
              <div *ngIf="All_FAF_FIN.Directory!=true && !CanDownload(All_FAF_FIN)"
                class="Container-Name-in-table dragstar Draggable-Name-Cell"
                [attr.draggable]="isMobileDevice ? 'false' : 'true'">
                <div *ngIf="Is_New_FIN_In_System(All_FAF_FIN.Date_Created)" class="Date-marker"><i
                    class="fa-brands fa-slack"></i></div> {{All_FAF_FIN.Name}}
              </div>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.ANNEX">
              <div *ngIf="!All_FAF_FIN.Directory" class="Container-Annexe">

                <button (click)="Can_See_Modal_Annexe(All_FAF_FIN)" class="Btn-Annexe Annexe">

                  <i class="fa-regular fa-paste"></i>

                  <div class="Tool-Tip T-Annexe Annexe">Ver annexos</div>
                </button>
              </div>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.CODEF">
              <div class="Description" *ngIf="!All_FAF_FIN.Directory">

                <div class="Text-Description">
                  {{Cut_Code(All_FAF_FIN.Code)}}
                </div>

                <button (click)="See_Code(All_FAF_FIN.Code)" *ngIf="All_FAF_FIN.Code.length > 15"
                  class="Btn-Description">
                  <i class="fa-regular fa-file-lines"></i>
                  <div class="Tool-Tip T-Description">Ver Código</div>
                </button>

              </div>

            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.DESCR">
              <div class="Description" *ngIf="!All_FAF_FIN.Directory">

                <div class="Text-Description">
                  {{Cut_Purpose(All_FAF_FIN.Purpose)}}
                </div>

                <button (click)="See_Purpose(All_FAF_FIN.Purpose)" *ngIf="All_FAF_FIN.Purpose.length > 32"
                  class="Btn-Description">
                  <i class="fa-regular fa-file-lines"></i>
                  <div class="Tool-Tip T-Description">Ver Objetivo</div>
                </button>

              </div>

            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.NOREV">
              <div *ngIf="!All_FAF_FIN.Directory">{{All_FAF_FIN.Revision_No}}</div>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header.startsWith('APPR')">
              <div *ngIf="!All_FAF_FIN.Directory" class="approver-cell">
                {{Get_Dynamic_Approver_Name(All_FAF_FIN.DynamicApprovers, Table_header.Key_Header)}}</div>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.DAMOD">
              <div *ngIf="!All_FAF_FIN.Directory">{{Get_Date_Modification(All_FAF_FIN.Date_Modification)}}</div>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.DACRE">
              <div *ngIf="!All_FAF_FIN.Directory">{{Get_Date_Created(All_FAF_FIN.Date_Created)}}</div>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.DAEXP">
              <div *ngIf="!All_FAF_FIN.Directory" class="Container-Expired">
                {{Get_Date_Expiration(All_FAF_FIN.Date_Expiration)}}
                <div class="Date-Expired {{Expiry_Status(All_FAF_FIN.Date_Expiration)}}">
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.STATU">
              <div *ngIf="!All_FAF_FIN.Directory">{{Status_string(All_FAF_FIN.Status)}}</div>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.CONTR">
              <div *ngIf="!All_FAF_FIN.Directory">{{All_FAF_FIN.Contributor_Name}}</div>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.AREA_">
              <div *ngIf="!All_FAF_FIN.Directory">{{All_FAF_FIN.Area}}</div>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_FIN.SHOP_">
              <div *ngIf="!All_FAF_FIN.Directory">{{All_FAF_FIN.Shop}}</div>
            </ng-container>


          </td>

        </tr>

      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr *ngIf="All_FAF_FIN.length>0">
          <td [attr.colspan]="FIN_Table_Headers.length + (IsMultiSelectMode ? 2 : 1)">Sin coincidencias.</td>
        </tr>
        <tr *ngIf="All_FAF_FIN.length===0 && LoadPage" class="Not-Files-tr">
          <td [attr.colspan]="FIN_Table_Headers.length + (IsMultiSelectMode ? 2 : 1)">
            <div class="Not-Files" *ngIf="All_FAF_FIN.length===0 && LoadPage">
              <div class="Img-Not">
                <img src="./assets/Global/Ilustrations/Not-Files.png" alt="">
              </div>
              <div class="Text-Not-Files">
                El directorio está vacío, no tiene procesos o carpetas.
              </div>
            </div>
          </td>
        </tr>
      </ng-template>

    </p-table>

  </div>


</div>

<!--&================== CONTAINER FOR ESTATUS FIN ==================&-->
<div *ngIf="Header_Routes.length==1" class="Section-Status title-components">
  <h1>Estatus Proceso</h1>
  <div class="Container-Status container-global-components">
    <div class="Description-Status">
      Consulte el estatus de cada uno de los procesos contribuidos.
    </div>
    <div class="btnStatus">
      <div (click)="See_FIN_Contributions()" class="btn-icon-text-left-outlined">
        <span class="text">Ver Estatus Procesos</span><i class="fa-brands fa-stack-overflow"></i>
      </div>
    </div>
  </div>
</div>

<!--~===================================== SECTION ALL MODALS =====================================~-->

<!---===================== MODAL FOR ADD NEW FOLDER =====================--->
<section class="Modal-Global" id="ModalAddFolderFIN">
  <div class="wrapper">
    <div class="Pro-popup3 popup" [ngClass]="{'expanded': ShowAdvancedConfig}">
      <div class="Pro-inside3 popup-inside" [ngClass]="{'expanded': ShowAdvancedConfig}">
        <div class="Pro-backgrounds3 backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>
      <form [formGroup]="FormAddFolderFIN" (ngSubmit)="AddFolder()">
        <div class="Pro-content3 content" [ngClass]="{'expanded': ShowAdvancedConfig}">
          <div class="Btn-Close" (click)="ToggleModalAddFolderFIN(false)"><i class="fa-solid fa-xmark"></i></div>
          <div class="Content-Top">
            <h2>Crear carpeta</h2>
          </div>

          <div class="Content-body">
            <div class="Content-grid-2">
              <div class="Text-icon">
                Nombre
              </div>
              <div class="Container-input Input-Text-Form" id="IdInputCodeNewFIN">
                <i class="fa-solid fa-signature"></i><input type="text" formControlName="NameFolderFIN">
              </div>
            </div>

            <!-- Sección de Configuración Avanzada -->
            <div class="Advanced-Config-Toggle" (click)="ShowAdvancedConfig = !ShowAdvancedConfig">
              <i class="fa-solid" [ngClass]="ShowAdvancedConfig ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              <span>Configuración Avanzada de Flujo</span>
            </div>

            <div class="Advanced-Config-Content" *ngIf="ShowAdvancedConfig">

              <div class="Config-Checkboxes" style="margin-bottom: 16px;" *ngIf="this.Route_Level_Global !== ''">
                <div class="Check-Row">
                  <label class="switch-label">
                    <input type="checkbox" formControlName="InheritanceGA">
                    <span class="slider"></span>
                  </label>
                  <span>Heredar flujo del padre</span>
                </div>
              </div>

              <div class="Groups-Assignment"
                *ngIf="this.Route_Level_Global === '' || !FormAddFolderFIN.value.InheritanceGA">
                <div class="Header-Dynamic-Groups">
                  <h6>Asignación de Grupos</h6>
                  <button type="button" class="btn-add-reviewer" (click)="AddReviewerRow()">
                    Agregar Revisor <i class="fa-solid fa-plus"></i>
                  </button>
                </div>

                <div class="Empty-Reviewers" *ngIf="FormAddFolderFIN.value.Groups.length === 0">
                  <i class="fa-solid fa-users-slash"></i>
                  <p>No hay revisores agregados</p>
                </div>

                <div class="Reviewer-Group-Row dynamic-row"
                  *ngFor="let groupRow of FormAddFolderFIN.value.Groups; let i = index">
                  <div class="Reviewer-Label">
                    {{ ReviewerHeaders[i]?.Name || 'Revisor ' + (i+1) }}
                  </div>

                  <div class="Selected-Group-Display" (click)="OpenModalSelectGroup(i)">
                    <div class="Group-Status-Icon" [ngClass]="groupRow.ID_G > 0 ? 'active' : 'inactive'">
                      <span>{{ GetGroupInitials(i) }}</span>
                    </div>
                    <span class="Group-Name-Text">{{ GetGroupName(i) }}</span>

                    <div class="Action-Buttons-Group">
                      <button type="button" class="btn-group-action change" title="Cambiar grupo aprobador">
                        <i class="fa-solid" [ngClass]="groupRow.ID_G > 0 ? 'fa-arrows-rotate' : 'fa-check'"></i>
                      </button>
                    </div>
                  </div>

                  <button type="button" class="btn-remove-row" (click)="RemoveReviewerRow(i)" title="Eliminar revisor">
                    <i class="fa-solid fa-trash-can"></i>
                  </button>
                </div>
              </div>

              <div class="OCR-Config-Section">
                <div class="OCR-Config-Header">
                  <i class="fa-solid fa-magnifying-glass-location"></i>
                  <h6>Extracción OCR por RegEx</h6>
                </div>

                <!-- Switch de Herencia (Solo si no es raíz) -->
                <div class="Config-Checkboxes" *ngIf="this.Route_Level_Global !== ''" style="margin-bottom: 12px;">
                  <div class="Check-Row">
                    <label class="switch-label">
                      <input type="checkbox" formControlName="OCR_Inheritance">
                      <span class="slider"></span>
                    </label>
                    <span>Heredar configuración del padre</span>
                  </div>
                </div>

                <!-- Input de RegEx (Si no se hereda o es raíz) -->
                <div class="Container-input Input-Text-Form"
                  *ngIf="!FormAddFolderFIN.value.OCR_Inheritance || this.Route_Level_Global === ''">
                  <i class="fa-solid fa-code"></i>
                  <input type="text" formControlName="OCR_Regex" placeholder="Ej: FOL-(\d+)">
                </div>
              </div>

            </div>

          </div>
          <div class="Content-Bottom">
            <button type="submit" class="Btn-LSave-Form3 btn-icon-text">
              <i class="fa-solid fa-check-double"></i><span class="text">Crear carpeta</span>
            </button>
            <div (click)="ToggleModalAddFolderFIN(false)" class="Btn-LCancel-Form Btn-Close-Modal">
              <span>Cerrar</span>
            </div>

          </div>
        </div>
      </form>
    </div>
  </div>
</section>


<app-add-new-fprocess-fin (IsUploadFINBool)="IsUploadFIN($event)" [Route_Level_Global]="this.Route_Level_Global"
  [Permission_FMF]="this.Permission_FMF" [All_FAF_FIN]="this.All_FAF_FIN">
</app-add-new-fprocess-fin>


<app-update-fprocess-fin (IsUpdateFINBool)="IsUpdateFIN($event)" [Route_Level_Global]="this.Route_Level_Global"
  [Permission_FMF]="this.Permission_FMF" [FormFINUpdate]="this.FormFINUpdate" [FFIN_Select_CM]="this.FFIN_Select_CM"
  [FileAuxUpdFIN_Annexes]="this.FileAuxUpdFIN_Annexes" [All_FAF_FIN]="this.All_FAF_FIN">
</app-update-fprocess-fin>


<app-context-menu-prcfin #contextMenuPrcFIN (IsChangeFIN)="IsChangeEventFIN($event)"
  (SelectForMoveEvent)="SelectForMove($event)" (PreviewFileEvent)="PreviewFile($event)" [All_FAF_FIN]="this.All_FAF_FIN"
  [FFIN_Select_CM]="this.FFIN_Select_CM" [Permission_FMF]="this.Permission_FMF"
  [IsMultiSelectMode]="IsMultiSelectMode" [SelectedALL_FAF_FIN]="SelectedALL_FAF_FIN"
  (DeleteMultipleEvent)="DeleteSelectedItems()">
</app-context-menu-prcfin>

<!---===================== MODAL FOR SELECT GROUP =====================--->
<section class="Modal-Global GA" id="ModalSelectGroupReviewer">
  <div class="wrapper">
    <div class="Pro-popupMGA popup">
      <div class="Pro-insideMGA popup-inside">
        <div class="Pro-backgroundsMGA backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <div class="Pro-contentMGA content">
        <div (click)="CloseModalSelectGroup()" class="Btn-Close">
          <i class="fa-solid fa-xmark"></i>
        </div>
        <div class="Content-Top">
          <h2>Seleccionar grupo {{ ReviewerHeaders[CurrentReviewerIndex]?.Name || ('Revisor ' + (CurrentReviewerIndex +
            1)) }}</h2>
          <h4>Seleccione el grupo que desea asignar</h4>
        </div>

        <div class="Content-body">
          <div class="SectionCreateTotal Section-Task">
            <div class="left-CT">
              <div class="Search inputText">
                <i class="fa-solid fa-magnifying-glass"></i>
                <input [(ngModel)]="SearchGroup" type="text" (keyup)="Search_GroupForm()" placeholder="Buscar grupo" />
              </div>
            </div>
          </div>

          <div class="Content-Cards">
            <div *ngFor="let group of GroupsFiltered" class="Card-G">
              <div class="Container-Img">
                <i class="fa-solid fa-users"></i>
              </div>

              <div class="Body-Card">
                <div class="Title">
                  <h3>{{ group.Nombre || group.Name }}</h3>
                </div>
                <div class="Description">
                  <p>{{ (group.Descripcion || group.Description) || 'sin descripcion' }}</p>
                </div>
                <div class="Button-Card">
                  <div class="btn-icon-text" (click)="SelectGroupForReviewer(group)">
                    <i class="fa-solid fa-check-double"></i>
                    <span class="text">Seleccionar</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <p-paginator (onPageChange)="onPageChangeGroupForm($event)" [first]="first_GA_Form" [rows]="rows_GA_Form"
          [totalRecords]="TotalGroupsForPaginator" [rowsPerPageOptions]="[5, 10, 15, 20, 30]">
        </p-paginator>
      </div>
    </div>
  </div>
</section>

<!---===================== MODAL FOR SEE ANNEXES =====================--->
<section class="Modal-Global Modal-See-Annexe" id="Modal-See-Annexe">
  <div class="wrapper">
    <div class="Pro-popup-See-Annexes1 popup">
      <div class="Pro-inside-See-Annexes1 popup-inside">
        <div class="Pro-backgrounds-See-Annexes1 backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <div class="Pro-content-See-Annexes1 content">
        <button (click)="Modal_See_Annexe(false)" class="Btn-Close"><i class="fa-solid fa-xmark"></i></button>
        <div class="Content-Top">
          <h2>Anexos</h2>
          <h4>Anexos de {{FFIN_Select_CM.Name}}</h4>
        </div>

        <div class="Content-body">

          <div class="Container-Annexes Container-Annexes-See">
            <div class="Container-Card-Annexes">

              <ng-container *ngIf="FFIN_Select_CM.Annexes.length>0;else Not_Annexes">
                <div *ngFor="let Annexe of FFIN_Select_CM.Annexes" class="Card-Annexes">

                  <div class="Container-File">
                    <ng-container *ngFor="let icon of Icons_Image">
                      <div *ngIf="Annexe.Extension.toUpperCase()==icon.Extension.toUpperCase()">
                        <img src="./assets/Global/icons/{{icon.Url_Image}}" alt="" srcset="">
                      </div>
                    </ng-container>
                    <div class="Name-Annexe">
                      {{CutNameFile(Annexe.Name,35)}}
                    </div>
                  </div>

                  <div class="Container-Buttons-Annexe">
                    <button
                      *ngIf="UserRoleIn([PermissionFIN.versionHistoryAnnexe]) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorFIN])"
                      (click)="See_Version_History_Annexe(Annexe)" type="button" class="button-square">
                      <i class="fa-solid fa-arrow-up-right-dots"></i>
                    </button>

                    <ng-container *ngIf="verifyAnnexeInFS(Annexe);else inFsFIN">
                      <button (click)="alertNotAnnexeInFS()" type="button" class="button-square error">
                        <i class="fa-solid fa-triangle-exclamation"></i>
                      </button>
                    </ng-container>

                    <ng-template #inFsFIN>
                      <button (click)="Can_Download_Annexe(Annexe)" type="button" class="button-square">
                        <i class="fa-solid fa-download"></i>
                      </button>
                    </ng-template>
                  </div>

                </div>
              </ng-container>

              <ng-template #Not_Annexes>

                <div class="Not-Annexes-See">
                  <div class="Img-Not-See">
                    <img src="./assets/Global/Ilustrations/Not-Annexes.png" alt="">
                  </div>
                  <div class="Text-See">
                    No hay anexos cargados en este proceso.
                  </div>
                </div>

              </ng-template>

              <i class="fa-solid fa-file-circle-plus"></i><span class="text">Carga múltiple</span>
            </div>
          </div>

          <div class="Container-Download-Annexe" id="Container-Download-Annexe">
            <div class="Container-progress-bar-Annexe">
              <span class="Progress-Bar-Annexe" id="Progress-Bar-Annexe"></span>
            </div>
          </div>

        </div>
        <div class="Content-Bottom Bottom-Modal-See-Annexe">
          <button (click)="Modal_See_Annexe(false)" class="Btn-Close-Modal ">
            <span>Cerrar</span>
          </button>

        </div>
      </div>

    </div>
  </div>
</section>

<!---===================== MODAL OPTIONS UPLOADS FIN =====================--->
<div class="Context-Menu-Option-Upload" id="Context-Menu-Option-Upload"
  (mouseleave)="ToggleModalContext_Menu_Option_Upload(false,$event)">
  <div class="Top-CM-Upload">
    <button (click)="ToggleModalContext_Menu_Option_Upload(false,$event)" type="button" id="Btn-Close-Update-Top"
      class="Btn-Close"><i class="fa-solid fa-xmark"></i></button>
  </div>
  <div class="Body-CM-Upload">
    <div class="Title-CM">
      <h3>Selecciona la opción para actualización </h3>
    </div>
    <div class="Options-CM">
      <button (click)="ToggleModal_Update_Annexes_Approved(true)"
        (click)="ToggleModalContext_Menu_Option_Upload(false, $event)" class="Btn-CM Update-Annexe">Actualizar
        anexos</button>
      <button (click)="ToggleModalUpdateFIN(true)" (click)="ToggleModalContext_Menu_Option_Upload(false, $event);"
        class="Btn-CM Update-Data">Actualización completa</button>
      <!-- <button (click)="ToggleModalUpdateFIN(true)" (click)="ToggleModalContext_Menu_Option_Upload(false, $event);" class="Btn-CM Update-Complete">Actualizar finanza</button> -->
    </div>
  </div>
  <div class="Footer-CM-Upload">

  </div>

</div>

<!---===================== MODAL FOR HELP ICONS =====================--->
<section class="Modal-Global" id="ModalIconsHelp">
  <div class="wrapper">
    <div class="Local-M-Icon-Popup popup">
      <div class="Local-M-Icon-inside popup-inside">
        <div class="Local-M-Icon-backgrounds backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>
      <div class="Local-M-Icon-content content">
        <div (click)="ToggleModalHelp(false)" class="Btn-Close"><i class="fa-solid fa-xmark"></i></div>
        <div class="Content-Top">
          <h2>Fecha de vencimiento</h2>
        </div>

        <div class="Content-body">
          <div class="Info-Icons">
            <div class="Header grid-column-2">
              <div class="Icon-container">
                Marcador
              </div>
              <div class="Description-T">
                Descripción
              </div>
            </div>
            <div *ngFor="let icon of StatusExpired;let i = index" class="grid-column-2">
              <div class="Icon-container">
                <div class="Icon-Status StatusExpired{{i+1}}">

                </div>
              </div>
              <div class="Description">
                {{icon.Description}}
              </div>
            </div>

          </div>
        </div>
        <div class="Local-M-Icon-Bottom Content-Bottom">
          <div (click)="ToggleModalHelp(false)" class="Btn-Close-Modal">
            <span>Cerrar</span>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>

<!---===================== MODAL FOR DOWNLOAD PROGRESS BAR FIN =====================--->
<section class="Modal-Global" id="ProgressModal">
  <div class="Content-DownloadTable">
    <div class="Tittle-Table">
      <h2>Descargando Proceso ...</h2>
    </div>
    <div class="Body-Table">
      <div class="Container-progress-bar">
        <span class="Progress-Bar-Table" id="Progress-Bar-Table"></span>
      </div>
    </div>
  </div>
</section>

<!---===================== MODAL FOR LOADER COMPONENT =====================--->
<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>

<div class="background-Sidebar {{Right_Sidebar_Visible?'active':''}}">
  <p-drawer [(visible)]="Right_Sidebar_Visible" position="right" [modal]="false" closeOnOutsideClick="true">
    <app-tree-move-proces-fin *ngIf="Right_Sidebar_Visible"
      (IsMoveFIN)="IsMove($event)"
      (ShowSideBar)="ShowSide($event)"
      [FFIN_Select_CM]="selectedItemToMove"
      [selectedItems]="selectedItemsToMove"
      (onPerformMove)="OnPerformMove($event)">
    </app-tree-move-proces-fin>
  </p-drawer>
</div>

<app-document-viewer [visible]="showPreview" [fileName]="previewFileName" [fileUrl]="previewFileUrl"
  [extension]="previewFileExtension" (onClose)="showPreview = false" (onDownload)="DownloadFromPreview()">
</app-document-viewer>

<!-- Fantasma para el arrastre táctil -->
<div *ngIf="isTouchDragging" class="Touch-Drag-Ghost" [style.left.px]="touchX" [style.top.px]="touchY">
  <ng-container *ngIf="touchDraggedItems && touchDraggedItems.length > 0">
    <i class="fa-solid" [ngClass]="touchDraggedItems.length > 1 ? 'fa-copy' : (touchDraggedItems[0].Directory ? 'fa-folder' : 'fa-file')"></i>
    <span>{{ touchDraggedItems.length > 1 ? touchDraggedItems.length + ' elementos seleccionados' : touchDraggedItems[0].Name }}</span>
  </ng-container>
</div>